import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/discover/DiscoverClient.tsx");
